<template>
    <router-link to="/"></router-link>
  <router-view/>
</template>

<style>
</style>
